<div class="form-container" id="descripteurs-om_form">
    <mat-card-title>
        <h2>Descripteurs de l'objet maquette</h2>
    </mat-card-title>
    @if (form) {
    <mat-card-content>
        <form data-tfa="form_descripteurs_objet_maquette" [formGroup]="form.asFormGroup">
            <!-- CHAMPS SPECIFIQUES OBJET-FORMATION -->
            <div class="form-field-group">
                @if (isObjetFormation) {
                <app-select-nomenclature
                    class="form-field"
                    [formFieldStyles]="{ 'margin': '10px', 'flex-grow': '2' }"
                    formControlName="type"
                    label="Type d'objet de formation"
                    [nomenclature]="NomenclatureType.TypeObjetFormation"
                    [contexteConsommation]="espace()"
                    [isParametrage]="true"
                >
                </app-select-nomenclature>
                }
            </div>
            <!-- END CHAMPS SPECIFIQUES OBJET-FORMATION -->
            <!-- CHAMPS SPECIFIQUES FORMATION -->
            <div class="form-field-group">
                @if (isFormation) {
                <app-select-nomenclature
                    class="form-field"
                    [formFieldStyles]="{ 'margin': '10px', 'flex-grow': '2' }"
                    formControlName="typeFormation"
                    label="Type de formation"
                    [nomenclature]="NomenclatureType.TypeFormation"
                    [contexteConsommation]="espace()"
                    [isParametrage]="true"
                    data-tfa="select-type-formation"
                ></app-select-nomenclature>
                }
            </div>
            <!-- END CHAMPS SPECIFIQUES FORMATION -->
            <!-- CHAMPS SPECIFIQUES GROUPEMENT -->
            @if (isGroupement) {
            <div class="form-field-group plage-de-choix" [formGroup]="form.asFormGroup">
                <div class="form-field center-toggle">
                    <mat-slide-toggle
                        [checked]="form.asFormGroup.controls.plageDeChoix.value"
                        data-tfa="slide-toggle-plage-de-choix"
                        (toggleChange)="onTogglePLageDeChoix()"
                        [disabled]="form.asFormGroup.controls.plageDeChoix.disabled"
                        >Plage de choix</mat-slide-toggle
                    >
                    @if (form.asFormGroup!.hasError('plageDeChoixMinMax')) {
                    <mat-error>La valeur min doit être inférieure à la valeur max</mat-error>
                    }
                </div>
                @if (form.asFormGroup.controls.plageDeChoix.value) {
                <mat-form-field class="form-field plage-de-choix-min-max">
                    <mat-label>Minimum</mat-label>
                    <input matInput data-tfa="input_plage-de-choix_min" formControlName="plageDeChoixMin" type="text" inputmode="numeric" />
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.plageDeChoixMin"></mat-error>
                </mat-form-field>
                } @if (form.asFormGroup.controls.plageDeChoix.value) {
                <mat-form-field class="form-field plage-de-choix-min-max">
                    <mat-label>Maximum</mat-label>
                    <input matInput data-tfa="input_plage-de-choix_max" formControlName="plageDeChoixMax" type="text" inputmode="numeric" />
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.plageDeChoixMax"></mat-error>
                </mat-form-field>
                }
            </div>
            }
            <!-- END CHAMPS SPECIFIQUES GROUPEMENT -->
            <div class="form-field-group">
                <mat-form-field class="form-field two-columns-form-field">
                    <mat-label>Libellé</mat-label>
                    <input
                        data-tfa="input_libelle_descripteurs_objet_maquette"
                        matInput
                        formControlName="libelle"
                        placeholder="Libelle"
                        (blur)="copyLibelleCourtToLibelleLong()"
                    />
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.libelle"></mat-error>
                </mat-form-field>
            </div>
            <div class="form-field-group">
                <mat-form-field class="form-field two-columns-form-field">
                    <mat-label>Libellé long</mat-label>
                    <input
                        data-tfa="input_libelle_long_descripteurs_objet_maquette"
                        matInput
                        formControlName="libelleLong"
                        placeholder="Libelle Long"
                    />
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.libelleLong"></mat-error>
                </mat-form-field>
            </div>
            <div class="form-field-group">
                @if (!isGroupement) {
                <mat-form-field class="form-field">
                    <mat-label>ECTS</mat-label>
                    <input
                        data-tfa="input_ects_descripteurs_objet_maquette"
                        type="text"
                        inputmode="numeric"
                        matInput
                        formControlName="ects"
                        placeholder="ECTS"
                    />
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.ects"></mat-error>
                </mat-form-field>
                } @if (!isGroupement) {
                <app-select-structure
                    [name]="'structurePrincipale'"
                    [label]="'Structure principale'"
                    [parent]="form.asFormGroup"
                ></app-select-structure>
                }
                <!-- Champ "nature" GPT -->
                @if (isGroupement) {
                <app-select-nomenclature
                    class="form-field"
                    [formFieldStyles]="{ margin: '10px' }"
                    formControlName="natureGroupement"
                    label="Nature de groupement"
                    [nomenclature]="NomenclatureType.NatureGroupement"
                    [contexteConsommation]="espace()"
                    [isParametrage]="true"
                    data-tfa="input_nature_gpt_descripteurs_objet_maquette"
                ></app-select-nomenclature>
                }
            </div>
            @if (isObjetFormation) {
            <div class="form-field-group">
                <!-- Champ "nature" OF -->
                <app-select-nomenclature
                    class="form-field"
                    [formFieldStyles]="{ margin: '10px' }"
                    formControlName="nature"
                    label="Nature"
                    [nomenclature]="NomenclatureType.NatureTypeObjetFormation"
                    [contexteConsommation]="espace()"
                    [isParametrage]="true"
                    data-tfa="input_nature_descripteurs_objet_maquette"
                ></app-select-nomenclature>
                <mat-form-field class="form-field">
                    <mat-label>Capacité d'accueil</mat-label>
                    <input
                        data-tfa="capaciteAccueil-input"
                        formControlName="capaciteAccueil"
                        matInput
                        type="text"
                        [appLimitInputValue]="form.asFormGroup.controls.capaciteAccueil"
                    />
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.capaciteAccueil"></mat-error>
                </mat-form-field>
            </div>
            }
            <div class="form-field-group stage-and-tele-enseignement-toggles-container" [formGroup]="form.asFormGroup">
                @if (isObjetFormation) {
                <mat-slide-toggle
                    data-tfa="input_stage_descripteurs_objet_maquette"
                    [checked]="form.asFormGroup.controls.stage.value"
                    (toggleChange)="onToggleStage()"
                    >Stage</mat-slide-toggle
                >
                } @if (!isGroupement) {
                <mat-slide-toggle
                    data-tfa="input_tele_enseignement_descripteurs_objet_maquette"
                    (toggleChange)="onToggleTeleenseignement()"
                    [checked]="form.asFormGroup.controls.teleEnseignement.value"
                    >Télé-enseignement</mat-slide-toggle
                >
                }
            </div>
        </form>
        @if (!!form) {
        <div class="buttons-horizontal-container">
            <ng-content select="#bouton-fermer-objet-maquette"></ng-content>
            @if (!hideSaveButton()) {
            <button
                data-tfa="objet-maquette-créer-button"
                mat-raised-button
                color="primary"
                [disabled]="!form.isValid || form.isPristine"
                (click)="modifierDescripteursObjetMaquetteHandler()"
            >
                <mat-icon data-tfa="icone-valider">check</mat-icon>
                Enregistrer
            </button>
            }
        </div>
        }
    </mat-card-content>
    }
</div>

<ng-template #modifierDescripteursObjetMaquetteValideeDialogTmpl>
    <p>
        Vous allez modifier des descripteurs @switch (typeObjetMaquette()) { @case (TypesObjetMaquette.Formation) {
        <span>d'une formation déjà validée</span>
        } @case (TypesObjetMaquette.ObjetFormation) {
        <span>d'un objet de formation déjà validé</span>
        } @case (TypesObjetMaquette.Groupement) {
        <span>d'un groupement déjà validé</span>
        } } . Si vous confirmez, ces modifications seront propagées dans les autres modules de Pégase.
    </p>
    <p class="modifierDescripteursObjetMaquetteValideeDialogTmpl-emphasized">
        Avant de confirmer il est de votre responsabilité de vérifier toutes les conséquences de cette action.
    </p>
    @switch (typeObjetMaquette()) { @case (TypesObjetMaquette.Groupement) {
    <span>
        <ul>
            <li>
                en cas d'élargissement/rétrécissement de la plage de choix, en cas de modification du type de groupement, pensez à vérifier
                les impacts sur les CHC (incomplets ou en sur nombre)
            </li>
            <li>etc</li>
        </ul>
    </span>
    } @default {
    <span>
        <ul>
            <li>
                en cas de modifications de LIBELLES et ECTS, pensez à vérifier les impacts sur les délibérations déjà réalisées et les
                relevés de notes déjà édités
            </li>
            <li>
                en cas de modification de la structure principale, pensez à vérifier les impacts sur les inscriptions (calcul des PJ
                demandées)
            </li>
            <li>etc</li>
        </ul>
    </span>
    } }
</ng-template>
